export const parseJSON = (jsonString: string): unknown => {
	try {
		return JSON.parse(jsonString)
	} catch (e) {
		console.error('Error parsing JSON', e)
		return {}
	}
}

export const parseTextForCurlyBraces = (text: string): { text: string; highlight: boolean }[] => {
	if (typeof text !== 'string') {
		return [{ text, highlight: false }]
	}
	const parts = []
	const regex = /\{(.*?)\}/g
	let lastIndex = 0
	let match

	while ((match = regex.exec(text)) !== null) {
		if (match.index > lastIndex) {
			parts.push({ text: text.slice(lastIndex, match.index), highlight: false })
		}
		parts.push({ text: match[1], highlight: true })
		lastIndex = regex.lastIndex
	}

	if (lastIndex < text.length) {
		parts.push({ text: text.slice(lastIndex), highlight: false })
	}

	return parts
}
